module.exports = __webpack_public_path__ + "img/setor-impressao-acao-camisetas.f74ec774.png";